import RegionSerializer from "../serializers/RegionSerializer";
import StateRegionSerializer from "../serializers/StateRegionSerializer";
import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class RegionRepository {
  REGIONS_BASE = "/api/regions";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getRegions(instance) {
    const token = await getToken(instance);
    const path = `${this.REGIONS_BASE}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.regions.map(region => (RegionSerializer.deSerialize(
      region
    ))));
  }

  async getRegionStates(instance, regionId) {
    const token = await getToken(instance);
    const path = `${this.REGIONS_BASE}/state?regionId=${regionId}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, true);

    return Promise.resolve(req.stateRegion.map(stateRegion => (StateRegionSerializer.deSerialize(
      stateRegion
    ))));
  }
}